import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subject } from 'rxjs';
import { filter, switchMap, take, takeUntil, tap } from 'rxjs/operators';
import { ReportsService } from 'src/app/reports/reports.service';
import { ConfirmDialogComponent } from 'src/app/shared/modules/alerts/confirm-dialog/confirm-dialog.component';
import { SubscriptionPlanService } from 'src/app/shared/service/subscription-plan.service';
import { ProspektrApi } from '../../api/prospektr.api';
import { UserState } from '../../state/user.state';
import { SampleReportComponent } from '../sample-report/sample-report.component';

@Component({
  selector: 'app-plan-information',
  templateUrl: './plan-information.component.html',
  styleUrls: ['./plan-information.component.scss'],
})
export class PlanInformationComponent implements OnInit {
  @Input() userRole;

  onDestroyNotifier$ = new Subject();
  plans = [];
  code = new FormControl();
  currentCode: any;
  totalPlans: any;
  connectedLoanOfficers: any;
  loanOfficer = new FormControl();
  selectedPlan: any = [];
  loading = true;
  spin = false;
  activePlanId: any;
  selectedPlanId: any;
  currentPlan: any = [];
  currentIndex: any;
  subscriptionEndDate: string;
  connectedLoanOfficerId: any;
  activePromoCode: any;
  existingSubscriptionEndDate: any;
  isConnected: boolean;
  activePlan: any;
  nextPlan: any;
  nextPlanId: any;
  nextLoanOfficer: any;
  nextPlanStartDate: string;
  isInTrial: boolean;
  loanOfficerChange: boolean;
  promoCodeChange: boolean;
  initialLO: any;
  hasAutoReset: boolean = false;
  activePlanName: any;
  disableTrialPlan: boolean = false;

  subscriptionMode: 'single' | 'bundle' = 'single';
  basePlans: any[] = [];
  bundlePlans: any[] = [];
  mandatoryBundles: any[] = [];
  selectedBundleIds: string[] = [];
  selectedBundles: any[] = [];
  bundleDiscount: any = null;
  bundleSummary: any = null;
  currentActiveBundles: any[] = [];
  currentActiveBundleIds: string[] = [];

  constructor(
    private reportsService: ReportsService,
    private userState: UserState,
    private prospektrApi: ProspektrApi,
    private snackBar: MatSnackBar,
    public dialog: MatDialog,
    private subscriptionService: SubscriptionPlanService,
    private cdr: ChangeDetectorRef,
  ) { }

  async ngOnInit(): Promise<void> {
    this.loading = true;
    this.updatePlans();
  }

  updatePlans() {
    this.userState.userPlanStatus.pipe(
      takeUntil(this.onDestroyNotifier$),
      filter((data): data is any => !!data),
      take(1),

      // STEP 1: Read user plan status
      tap((data) => this.applyUserPlanStatus(data)),

      // STEP 2: Fetch plans list from API
      switchMap(() => this.reportsService.getPlans()),

      // STEP 3: Now read plans from state
      // switchMap(() =>
      //   this.userState.plans.pipe(
      //     filter(plans => Array.isArray(plans) && plans.length > 0),
      //     take(1)
      //   )
      // ),
      switchMap(() =>
        this.userState.plans.pipe(
          filter((plansData): plansData is any => {
            if (!plansData) return false;

            if (plansData.mode === 'bundle') {
              return Array.isArray(plansData.basePlans) && Array.isArray(plansData.bundles);
            }

            return Array.isArray(plansData.plans);
          }),
          take(1)
        )
      ),

      // STEP 4: Process plans
      // tap((plansData) => {
      //   if (!plansData) return;

      //   // Step 1: Sort by priority (desc)
      //   const sortedPlans = [...plansData].sort((a, b) => b.priority - a.priority);

      //   // Step 2: Keep only one plan per priority
      //   const uniquePlansMap = new Map<number, any>();

      //   for (const plan of sortedPlans) {
      //     if (!uniquePlansMap.has(plan.priority)) {
      //       // First plan for this priority
      //       uniquePlansMap.set(plan.priority, plan);
      //     } else {
      //       // Priority already exists → prefer activePlanId
      //       const existingPlan = uniquePlansMap.get(plan.priority);
      //       if (plan.id === this.activePlanId) {
      //         uniquePlansMap.set(plan.priority, plan);
      //       }
      //     }
      //   }

      //   // Final plans list
      //   this.plans = Array.from(uniquePlansMap.values());

      //   // Optional: find active plan index
      //   const index = this.plans.findIndex(p => p.id === this.activePlanId);

      //   if (index > 0) {
      //     this.disableTrialPlan = true;
      //   } else {
      //     this.disableTrialPlan = false;
      //   }

      //   if (this.activePlanId && index !== -1) {
      //     this.activePlan = this.plans[index];
      //     this.selectedPlan = this.plans[index];
      //   } else {
      //     // Fallback: unlimited → trial → first plan
      //     let defaultIndex = this.plans.findIndex(x => x.planType === 'unlimited');

      //     if (defaultIndex === -1) {
      //       defaultIndex = this.plans.findIndex(x => x.isTrial);
      //     }

      //     if (defaultIndex === -1) {
      //       defaultIndex = 0; // final fallback
      //     }
      //     this.activePlan = this.plans[defaultIndex];
      //     this.selectedPlan = this.plans[defaultIndex];
      //     this.activePlanId = this.plans[defaultIndex]?.id;

      //     if (!this.hasAutoReset) {
      //       this.hasAutoReset = true;   // <-- ensure only once
      //       this.subscribePlan("resetToUnlimitedPlan");
      //     }
      //   }

      //   // --- Apply Promo Code ---
      //   if (this.activePromoCode) {
      //     let pIndex = this.plans.findIndex((x) => x.id === this.activePlanId);

      //     if (pIndex !== -1) {
      //       Object.assign(this.plans[pIndex], {
      //         discountPrice: this.activePromoCode?.discountedPrice ?? null,
      //         offerApplied: true,
      //         promoCode: this.activePromoCode?.promoCode ?? null,
      //       });
      //     }
      //   }

      //   // --- Next Plan Transition ---
      //   this.applyNextPlanTransition();
      //   this.cdr.detectChanges();
      // })

      tap((plansData) => {
        if (!plansData) return;

        this.processPlansResponse(plansData);

        if (this.activePromoCode && this.subscriptionMode === 'single') {
          let pIndex = this.plans.findIndex((x) => x.id === this.activePlanId);

          if (pIndex !== -1) {
            Object.assign(this.plans[pIndex], {
              discountPrice: this.activePromoCode?.discountedPrice ?? null,
              offerApplied: true,
              promoCode: this.activePromoCode?.promoCode ?? null,
            });
          }
        }

        this.applyNextPlanTransition();
        this.cdr.detectChanges();
      })
    )
      .subscribe({
        next: () => {
          this.loading = false;
        },
        error: (err) => {
          console.error('Error during updatePlans():', err);
          this.loading = false;
        }
      });
  }

  refreshUserPlanStatus(): void {
    this.userState.userPlanStatus
      .pipe(
        take(1),
        filter(Boolean)
      )
      .subscribe((data) => {
        this.applyUserPlanStatus(data);
        this.applyNextPlanTransition();
        this.cdr.detectChanges();
      });
  }

  private applyUserPlanStatus(data: any): void {
    if (!data) return;

    this.isInTrial = !!(!data.trialExpired && data.daysRemaining);
    this.activePlanId = data?.planId ?? null;
    this.activePlanName = data?.name ?? '';
    this.connectedLoanOfficerId = data?.loanOfficerId ?? '';
    this.initialLO = this.connectedLoanOfficerId;
    this.activePromoCode = data?.discounts ?? null;
    this.existingSubscriptionEndDate = data?.existingSubscriptionEndDate ?? null;
    this.nextPlan =
      data?.transitionToPlanDetails ||
      data?.transitionToSubscriptionDetails ||
      null;

    this.currentActiveBundles = Array.isArray(data?.activeBundles) ? data.activeBundles : [];
    this.currentActiveBundleIds = this.currentActiveBundles.map((bundle) => String(bundle.id));
    this.bundleDiscount = data?.bundleDiscount ?? null;
  }

  private applyNextPlanTransition() {
    if (!this.nextPlan || !this.existingSubscriptionEndDate) return;

    this.nextPlanId = this.nextPlan?.planId || this.nextPlan?._id;
    this.nextLoanOfficer = this.nextPlan?.loanOfficerId ?? '';

    const date = new Date(this.existingSubscriptionEndDate);
    if (!isNaN(date.getTime())) {
      this.nextPlanStartDate = `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
    }
  }

  viewSampleReport() {
    const matDialogRef = this.dialog.open(SampleReportComponent, {
      width: '70%',
      height: '100%',
      disableClose: false,
      hasBackdrop: true,
      data: {
        proceedAction: () => {
          matDialogRef.close();
        },
      },
    });
  }

  applyCode(id, index) {
    if (index != -1) {
      this.currentIndex = index;
      this.spin = true;
    }
    let obj = {
      planId: id,
      promoCode: this.code.value,
    };
    let i = this.plans.findIndex((x) => x.id == id);
    this.prospektrApi
      .applyCode(obj)
      .pipe(takeUntil(this.onDestroyNotifier$))
      .subscribe(
        (res: any) => {
          this.spin = false;
          this.openSnackBar(res.message, 'snackbar-success');
          this.plans[i]['discountPrice'] = res.data.discountedPrice;
          this.plans[i]['offerApplied'] = true;
          this.plans[i]['promoCode'] = this.code.value;
          this.currentCode = this.plans[i]['promoCode'];
        },
        (err: any) => {
          this.spin = false;
          this.plans[i]['offerApplied'] = false;
          this.plans[i]['discountPrice'] = '';
          this.code.reset();
          this.openSnackBar(err.error.message, 'snackbar-warning');
        }
      );
  }

  removeCode(id) {
    let i = this.plans.findIndex((x) => x.id == id);
    this.plans[i]['offerApplied'] = false;
    this.plans[i]['discountPrice'] = '';
    this.plans[i]['promoCode'] = '';
    this.code.reset();
  }

  ngOnDestroy() {
    this.onDestroyNotifier$.next();
    this.onDestroyNotifier$.complete();
  }

  // save() {
  //   if (this.activePlan.priority > this.selectedPlan.priority && this.activePlan.planType == 'subscription' && this.selectedPlan.planType == 'subscription') {
  //     const dialogRef = this.dialog.open(ConfirmDialogComponent, {
  //       data: {
  //         message: `Your current ${this.activePlan.product} subscription will be terminated immediately. You will be charged for the  ${this.selectedPlan.product}`,
  //         title: 'Are you sure you want to proceed?',
  //         proceedAction: (status, callBack) => {
  //           this.subscribePlan();
  //           dialogRef.close();
  //         },
  //         proceedCancelAction(cancelCallBack) {
  //         },
  //       },
  //       disableClose: true,
  //       hasBackdrop: true,
  //     });
  //   } else {
  //     this.subscribePlan();
  //   }
  // }

  save() {
    if (this.subscriptionMode === 'bundle') {
      const basePlanChanged = this.selectedPlan?.id && this.selectedPlan.id !== this.activePlanId;

      if (basePlanChanged) {
        if (
          this.activePlan.priority > this.selectedPlan.priority &&
          this.activePlan.planType == 'subscription' &&
          this.selectedPlan.planType == 'subscription'
        ) {
          const dialogRef = this.dialog.open(ConfirmDialogComponent, {
            data: {
              message: `Your current ${this.activePlan.product} subscription will be terminated immediately. You will be charged for the ${this.selectedPlan.product}`,
              title: 'Are you sure you want to proceed?',
              proceedAction: () => {
                this.subscribePlan();
                dialogRef.close();
              },
              proceedCancelAction() { },
            },
            disableClose: true,
            hasBackdrop: true,
          });
        } else {
          this.subscribePlan();
        }
      } else {
        this.saveBundles();
      }

      return;
    }

    if (
      this.activePlan.priority > this.selectedPlan.priority &&
      this.activePlan.planType == 'subscription' &&
      this.selectedPlan.planType == 'subscription'
    ) {
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        data: {
          message: `Your current ${this.activePlan.product} subscription will be terminated immediately. You will be charged for the  ${this.selectedPlan.product}`,
          title: 'Are you sure you want to proceed?',
          proceedAction: () => {
            this.subscribePlan();
            dialogRef.close();
          },
          proceedCancelAction() { },
        },
        disableClose: true,
        hasBackdrop: true,
      });
    } else {
      this.subscribePlan();
    }
  }

  subscribePlan(flag = null) {
    this.loading = true;
    this.activePromoCode?.promoCode == this.selectedPlan?.promoCode
      ? (this.promoCodeChange = false)
      : (this.promoCodeChange = true);
    let obj = {
      planId: this.selectedPlan.id,
      promoCode: this.selectedPlan?.promoCode,
      loanOfficerId: this.loanOfficer.value,
      loanOfficerChange: this.loanOfficerChange,
      promoCodeChange: this.promoCodeChange,
    };
    this.prospektrApi
      .subscribePlan(obj)
      .pipe(takeUntil(this.onDestroyNotifier$))
      .subscribe(
        (res: any) => {
          this.loading = false;
          this.currentPlan = this.selectedPlan;
          this.code.reset();

          if (res.data.existingSubscriptionEndDate) {
            let date = new Date(res.data.existingSubscriptionEndDate);
            let month = date.getMonth() + 1;
            this.subscriptionEndDate = date.getDate() + '/' + month + '/' + date.getFullYear();
            this.openSnackBar(
              res.message + '.' + 'This Plan will be effective only after ' + this.subscriptionEndDate,
              'snackbar-success'
            );
          } else {
            if (!flag) {
              this.openSnackBar(res.message, 'snackbar-success');
            }
          }

          this.subscriptionService.getSubscriptionPlan();

          if (this.subscriptionMode === 'bundle') {
            this.saveBundles();
            return;
          }

          this.reportsService.getPlanStatusNew().subscribe({
            next: (data) => {
              if (data) {
                this.refreshUserPlanStatus();
              }
            },
            error: (err) => {
              console.error(err);
            }
          });
        },
        // (res: any) => {
        //   this.loading = false;
        //   this.currentPlan = this.selectedPlan;
        //   this.code.reset();
        //   if (res.data.existingSubscriptionEndDate) {
        //     let date = new Date(res.data.existingSubscriptionEndDate);
        //     let month = date.getMonth() + 1;
        //     this.subscriptionEndDate = date.getDate() + '/' + month + '/' + date.getFullYear();
        //     this.openSnackBar(
        //       res.message + '.' + 'This Plan will be effective only after ' + this.subscriptionEndDate,
        //       'snackbar-success'
        //     );
        //   } else {
        //     if (!flag) {
        //       this.openSnackBar(res.message, 'snackbar-success');
        //     }
        //     // this.setUserDetailsAfterPlanChange();
        //   }
        //   this.subscriptionService.getSubscriptionPlan();
        //   this.reportsService.getPlanStatusNew().subscribe({
        //     next: (data) => {
        //       if (data) {
        //         this.refreshUserPlanStatus();
        //       }
        //     },
        //     error: (err) => {
        //       console.error(err);
        //     }
        //   });
        // },
        (err: any) => {
          this.loading = false;
          this.code.reset();
          this.openSnackBar(err.error.message, 'snackbar-error');
        }
      );
  }

  setUserDetailsAfterPlanChange() {
    if (!this.selectedPlan || !this.selectedPlan.id) {
      return;
    }

    const user = { ...this.userState.userDetails };
    user.activePlan = this.selectedPlan.id;
    this.activePlan = this.selectedPlan;

    const consumableRemaining = {};

    if (this.selectedPlan.featureList) {
      for (const feature of Object.keys(this.selectedPlan.featureList)) {
        const limit = this.selectedPlan.featureList[feature].usageLimit;

        if (limit === -1) {
          consumableRemaining[feature] = -1; // unlimited
        } else if (limit > 0) {
          consumableRemaining[feature] = limit;
        }
      }
    }

    user.consumableRemaining = consumableRemaining;
    this.userState.userDetails = user;
  }


  choosePlan(id) {
    this.selectedPlanId = id;
    this.connectedLoanOfficerId = this.loanOfficer.value;
    let i = this.plans.findIndex((x) => x.id == id);
    this.selectedPlan = this.plans[i];
  }

  private openSnackBar(message, style) {
    if (message) {
      this.snackBar.open(message, '', {
        duration: 3000,
        panelClass: [style ? style : ''],
        verticalPosition: 'top',
      });
    }
  }

  private processPlansResponse(plansData: any): void {
    if (!plansData) return;

    this.subscriptionMode = plansData.mode || 'single';

    if (this.subscriptionMode === 'bundle') {
      this.basePlans = Array.isArray(plansData.basePlans) ? plansData.basePlans : [];
      this.bundlePlans = Array.isArray(plansData.bundles) ? plansData.bundles : [];
      this.mandatoryBundles = Array.isArray(plansData.mandatoryBundles)
        ? plansData.mandatoryBundles
        : [];

      // Deduplicate base plans only
      const sortedBasePlans = [...this.basePlans].sort((a, b) => b.priority - a.priority);
      const uniquePlansMap = new Map<number, any>();

      for (const plan of sortedBasePlans) {
        if (!uniquePlansMap.has(plan.priority)) {
          uniquePlansMap.set(plan.priority, plan);
        } else {
          const existingPlan = uniquePlansMap.get(plan.priority);
          if (plan.id === this.activePlanId) {
            uniquePlansMap.set(plan.priority, plan);
          }
        }
      }

      this.basePlans = Array.from(uniquePlansMap.values());
      this.plans = this.basePlans;

      const activeBaseIndex = this.basePlans.findIndex((p) => p.id === this.activePlanId);

      if (activeBaseIndex > 0) {
        this.disableTrialPlan = true;
      } else {
        this.disableTrialPlan = false;
      }

      if (this.activePlanId && activeBaseIndex !== -1) {
        this.activePlan = this.basePlans[activeBaseIndex];
        this.selectedPlan = this.basePlans[activeBaseIndex];
      } else {
        let defaultIndex = this.basePlans.findIndex((x) => x.planType === 'unlimited');

        if (defaultIndex === -1) {
          defaultIndex = this.basePlans.findIndex((x) => x.isTrial);
        }

        if (defaultIndex === -1) {
          defaultIndex = 0;
        }

        this.activePlan = this.basePlans[defaultIndex];
        this.selectedPlan = this.basePlans[defaultIndex];
        this.activePlanId = this.basePlans[defaultIndex]?.id;
      }

      // Preselect mandatory bundles
      const mandatoryIds = this.mandatoryBundles.map((bundle) => String(bundle.id));
      const existingSelectedIds = this.currentActiveBundleIds || [];

      this.selectedBundleIds = Array.from(new Set([...mandatoryIds, ...existingSelectedIds]));

      const allSelectable = [...this.mandatoryBundles, ...this.bundlePlans];
      this.selectedBundles = allSelectable.filter((item) =>
        this.selectedBundleIds.includes(String(item.id))
      );

      this.updateBundleSummary();

      return;
    }

    // single mode old logic
    const sortedPlans = [...plansData.plans].sort((a, b) => b.priority - a.priority);
    const uniquePlansMap = new Map<number, any>();

    for (const plan of sortedPlans) {
      if (!uniquePlansMap.has(plan.priority)) {
        uniquePlansMap.set(plan.priority, plan);
      } else {
        const existingPlan = uniquePlansMap.get(plan.priority);
        if (plan.id === this.activePlanId) {
          uniquePlansMap.set(plan.priority, plan);
        }
      }
    }

    this.plans = Array.from(uniquePlansMap.values());

    const index = this.plans.findIndex((p) => p.id === this.activePlanId);

    if (index > 0) {
      this.disableTrialPlan = true;
    } else {
      this.disableTrialPlan = false;
    }

    if (this.activePlanId && index !== -1) {
      this.activePlan = this.plans[index];
      this.selectedPlan = this.plans[index];
    } else {
      let defaultIndex = this.plans.findIndex((x) => x.planType === 'unlimited');

      if (defaultIndex === -1) {
        defaultIndex = this.plans.findIndex((x) => x.isTrial);
      }

      if (defaultIndex === -1) {
        defaultIndex = 0;
      }

      this.activePlan = this.plans[defaultIndex];
      this.selectedPlan = this.plans[defaultIndex];
      this.activePlanId = this.plans[defaultIndex]?.id;

      if (!this.hasAutoReset) {
        this.hasAutoReset = true;
        this.subscribePlan('resetToUnlimitedPlan');
      }
    }
  }

  toggleBundle(bundle: any): void {
    if (!bundle || !bundle.id) return;

    const isMandatory = !!bundle.isMandatory;
    if (isMandatory) return;

    const id = bundle.id;
    const exists = this.selectedBundleIds.includes(id);

    if (exists) {
      this.selectedBundleIds = this.selectedBundleIds.filter((bundleId) => bundleId !== id);
    } else {
      this.selectedBundleIds = [...this.selectedBundleIds, id];
    }

    const allSelectable = [...this.mandatoryBundles, ...this.bundlePlans];
    this.selectedBundles = allSelectable.filter((item) => this.selectedBundleIds.includes(item.id));
    this.updateBundleSummary();
  }

  isBundleSelected(bundleId: string): boolean {
    return this.selectedBundleIds.includes(bundleId);
  }

  private updateBundleSummary(): void {
    const selectedBundlePlans = [...this.mandatoryBundles, ...this.bundlePlans].filter((bundle) =>
      this.selectedBundleIds.includes(bundle.id)
    );

    const totalBundleAmount = selectedBundlePlans.reduce((sum, bundle) => {
      return sum + Number(bundle.amount || 0);
    }, 0);

    let discount = null;
    if (selectedBundlePlans.filter((bundle) => bundle.discountEligible !== false).length >= 3) {
      discount = { type: 'percent', value: 15 };
    } else if (
      selectedBundlePlans.filter((bundle) => bundle.discountEligible !== false).length >= 2
    ) {
      discount = { type: 'percent', value: 10 };
    }

    let discountAmount = 0;
    if (discount?.type === 'percent') {
      discountAmount = (totalBundleAmount * discount.value) / 100;
    }

    this.bundleDiscount = discount;
    this.bundleSummary = {
      totalBundleAmount,
      discountAmount,
      finalBundleAmount: totalBundleAmount - discountAmount,
    };
  }

  saveBundles(): void {
    this.loading = true;

    const payload = {
      bundleIds: this.selectedBundleIds,
    };

    this.prospektrApi
      .subscribeBundles(payload)
      .pipe(takeUntil(this.onDestroyNotifier$))
      .subscribe(
        (res: any) => {
          this.loading = false;
          this.openSnackBar(res.message, 'snackbar-success');

          this.subscriptionService.getSubscriptionPlan();
          this.reportsService.getPlanStatusNew().subscribe({
            next: () => {
              this.refreshUserPlanStatus();
            },
            error: (err) => {
              console.error(err);
            },
          });
        },
        (err: any) => {
          this.loading = false;
          this.openSnackBar(err.error.message, 'snackbar-error');
        }
      );
  }
}
